import * as PIXI from "pixi.js";
import { AbstractViewProperties } from "./AbstractViewProperties";
/**
 * AbstractOverlayProperties.ts
 */
export class AbstractOverlayProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.particleProperties = [];
    }
}
/**
 * OverlayParticleProperties.ts
 */
export class OverlayParticleProperties extends AbstractViewProperties {
    equals(other) {
        return super.equals(other) &&
            this.id === other.id &&
            this.source === other.source &&
            this.destination === other.destination &&
            this.sourceId === other.sourceId &&
            this.destinationId === other.destinationId &&
            (this.spriteProperties ? this.spriteProperties.equals(other.spriteProperties) : this.spriteProperties === other.spriteProperties) &&
            (this.spineProperties ? this.spineProperties.equals(other.spineProperties) : this.spineProperties === other.spineProperties) &&
            this.sourceOffset === other.sourceOffset &&
            this.destinationOffset === other.destinationOffset &&
            this.ease === other.ease &&
            this.duration === other.duration &&
            this.delay === other.delay;
    }
    constructor(options) {
        super();
        this.id = options.id;
        this.source = options.source;
        this.destination = options.destination;
        this.sourceId = options.sourceId;
        this.destinationId = options.destinationId;
        this.spriteProperties = options.spriteProperties;
        this.spineProperties = options.spineProperties;
        this.sourceOffset = options.sourceOffset || new PIXI.Point();
        this.destinationOffset = options.destinationOffset || new PIXI.Point();
        this.ease = options.ease;
        this.duration = options.duration;
        this.delay = options.delay;
    }
}
//# sourceMappingURL=AbstractOverlayProperties.js.map